module.exports = __webpack_public_path__ + "img/station_icon_orange_1.097cab99.svg";